import { useState, useEffect } from 'react';

export const useMobileNavigation = () => {
    const [isLeftDrawerOpen, setIsLeftDrawerOpen] = useState(false);
    const [isRightDrawerOpen, setIsRightDrawerOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);

        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    const openLeftDrawer = () => setIsLeftDrawerOpen(true);
    const closeLeftDrawer = () => setIsLeftDrawerOpen(false);
    const toggleLeftDrawer = () => setIsLeftDrawerOpen(prev => !prev);

    const openRightDrawer = () => setIsRightDrawerOpen(true);
    const closeRightDrawer = () => setIsRightDrawerOpen(false);
    const toggleRightDrawer = () => setIsRightDrawerOpen(prev => !prev);

    const closeAllDrawers = () => {
        setIsLeftDrawerOpen(false);
        setIsRightDrawerOpen(false);
    };

    return {
        isMobile,
        isLeftDrawerOpen,
        isRightDrawerOpen,
        openLeftDrawer,
        closeLeftDrawer,
        toggleLeftDrawer,
        openRightDrawer,
        closeRightDrawer,
        toggleRightDrawer,
        closeAllDrawers,
    };
};
